import CustomDatePicker from '../Components/CustomDatePicker';
import { CustomInput, CustomSelect, CustomTextarea } from '../Components/CustomFormElements';
import WorkScheduler from '../Components/WorkScheduler';
import { TaskScheduleForm as FormState, TaskScheduleFormProps } from './TaskScheduleHelpers';

function TaskScheduleForm({ form, agents, isDisabled = false, onChange }: TaskScheduleFormProps) {
  const set = (partial: Partial<FormState>) => onChange({ ...form, ...partial });

  return (
    <>
      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title mr-3">Task Schedule Name</div>
          <div className="small-font">Enter task schedule name</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomInput
            id="task-schedule-name"
            label="Task Schedule Name"
            placeholder="Enter task schedule name"
            type="text"
            value={form.name}
            onChange={(_, value) => set({ ...form, name: value })}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title mr-3">Task Definition</div>
          <div className="small-font">Enter task definition</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomTextarea
            id="task-definition"
            label="Task Definition"
            mandatory={true}
            disabled={isDisabled}
            addedText={form.taskDefinition}
            onChange={(value) => set({ taskDefinition: value })}
            resizable={false}
            height="200px"
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Agent</div>
          <div className="small-font">Select an agent</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomSelect
            id="agent-select"
            label="Agent"
            options={agents.map((a) => ({
              value: a.key,
              label: a.name,
            }))}
            value={form.assistantKey}
            multiSelect={false}
            onChange={(val) => set({ ...form, assistantKey: val as string })}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Start Date</div>
          <div className="small-font">Select start date</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomDatePicker
            name="Start Date"
            value={form.startDate}
            onChange={(value) => set({ ...form, startDate: value })}
            max={form.endDate}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">End Date</div>
          <div className="small-font">Select end date</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomDatePicker
            name="End Date"
            value={form.endDate}
            onChange={(value) => set({ ...form, endDate: value })}
            min={form.startDate}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Trigger on</div>
          <div className="small-font">Select trigger</div>
        </div>
        <div className="align-wrapper d-flex flex-column">
          <WorkScheduler
            schedule={form.schedule}
            setSchedule={(schedule) => set({ ...form, schedule })}
            isDisabled={false}
            showEndTime={false}
          />
        </div>
      </div>
    </>
  );
}

export default TaskScheduleForm;
